<script setup lang="ts">
import {
  Select as ShadSelect,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/cms/components/ui/select/index.ts";
import {
  SelectProps,
  SelectEvents,
  SelectOptionGroup,
  SelectOption,
} from "@/cms/inputs/Select/Select.types.ts";
import InputWrapper from "@/cms/inputs/shared/InputWrapper.vue";
import { computed, useAttrs } from "vue";

const attrs = useAttrs();

const props = defineProps<SelectProps>();
defineEmits<SelectEvents>();

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<string>({ required: true });

const isGroupedOptions = computed(() =>
  props.options.some((option) => "options" in option)
);

const groupedOptions = computed(
  () => props.options as Array<SelectOptionGroup>
);
const ungroupedOptions = computed(() => props.options as Array<SelectOption>);

const filteredAttrs = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { options, ...others } = attrs;
  return others;
});
</script>

<template>
  <InputWrapper :label :help :error :info :field-id="id">
    <ShadSelect
      v-bind="filteredAttrs"
      v-model="model"
      @blur="$emit('blur', $event)"
    >
      <SelectTrigger :id :data-dd="`CMS Select: ${label}`">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <template v-if="isGroupedOptions">
          <template v-for="group in groupedOptions" :key="group.label">
            <SelectGroup>
              <SelectLabel>{{ group.label }}</SelectLabel>
              <SelectItem
                v-for="option in group.options"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.label }}
              </SelectItem>
            </SelectGroup>
          </template>
        </template>
        <template v-else>
          <SelectGroup>
            <SelectItem
              v-for="option in ungroupedOptions"
              :key="option.value"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.label }}
            </SelectItem>
          </SelectGroup>
        </template>
      </SelectContent>
    </ShadSelect>
  </InputWrapper>
</template>
